import React from "react";
import { CursorPoint } from "../style";

const CopyIcon = (props) => {
  return (
    <CursorPoint>
     <svg fill="none" height="7" width="14" xmlns="http://www.w3.org/2000/svg"><title>Dropdown</title><path d="M12.75 1.54001L8.51647 5.0038C7.77974 5.60658 6.72026 5.60658 5.98352 5.0038L1.75 1.54001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" xmlns="http://www.w3.org/2000/svg"></path></svg>
    </CursorPoint>
  );
};

export default CopyIcon;